import { useSyncExternalStore } from 'react';

let isOpen = false;
const listeners = new Set<() => void>();

function notifyListeners() {
  for (const listener of listeners) listener();
}

export function openCommandPalette() {
  if (isOpen) return;
  isOpen = true;
  notifyListeners();
}

export function closeCommandPalette() {
  if (!isOpen) return;
  isOpen = false;
  notifyListeners();
}

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function useCommandPaletteOpen(): boolean {
  return useSyncExternalStore(
    subscribe,
    () => isOpen,
    () => false,
  );
}
